import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as localForage from "localforage";
import { forkJoin } from "rxjs";
import { ApiConstant } from "src/app/constants/app.constant";
import { IResp } from "src/app/metadata/interfaces/IResp";

@Injectable({
  providedIn: "root",
})
export class HandleDataService {
  isLoaded = false;

  private _doors: any;

  constructor(private _Http: HttpClient) {}

  getDoors() {
    if (this._doors) return this._doors;
    // this.loadFromStorage() ? ("Data Available") : ("Error: Data Unavailable in Local Storage!");
    return this._doors;
  }

  setDoors(response) {
    if (response.status === 200) this._doors = response;
    else console.error("Bad Response!");
  }

  cacheToStorage() {
    let _doors = JSON.stringify(this._doors);
    // sessionStorage.setItem('doorsResponse', _doors);
    localForage.setItem("doorResponse", _doors);
    return 1;
  }

  loadFromStorage() {
    let _doors = sessionStorage.getItem("doorsResponse");

    this._doors = JSON.parse(_doors);
    if (!_doors) return 0;
    return 1;
  }

  async GetDoorData(limit = 2000): Promise<IResp> {
    return {
      _Status: true,
      _Data: [],
      _ErrorCode: 0,
    };
    let url = `${ApiConstant.baseUrlV4}Door/QueryBuilder`;
    let payload : any ={
      _Limit: limit,
      _Skip: 0,
      LastUpdated: null,
      Order: {
        DoorMonitoring: "_DoorID DESC",
      },
      Fields: {
        DoorMonitoring:
          "_DoorID;_DoorName;_LockType;_TimeTableID;_LockType;_LockID;_UserDefApAddr;_IpAddress;_IsAchieved",
        HardwareTemplate: "_Name; _EnableFreePassage",
        AccessServiceDoor: "count",
        WifiTask: "count",
        WeeklyProgram: "_WeekProgramName",
        LockCompose: "count",
        DoorInfo:
          "_Voltage;_BatteryStatus;_OnlineStatus;_DoorAlarm;_DoorState;_SignalStrenght;_FwVersion",
      },
      WHERE: {
        DoorMonitoring: "_IsAchieved=0",
      },
      Condition: "" 
    }
    try {
      const response = await this._Http.post(url, payload).toPromise();
      return {
        _Status: true,
        _Data: response,
        _ErrorCode: 0,
      };
    } catch (error: any) {
      return {
        _Status: false,
        _Data: error.message || "An unknown error occurred",
        _ErrorCode: 500,
      };
    }
  }

  getDoorList() {
    const payload = {
      limit: 2000,
      skip: 0,
    };
    return this._Http.post(`${ApiConstant.baseUrlV4}Door/DoorList`, payload);
  }

  getDashboardData() { 
    const requests = [
      this._Http.post(
        ApiConstant.baseUrlV2 + "defaultstatistics/CallDefaultstat",
        {
          _ApYear: "2021",
        }
      ),
      this._Http.get(ApiConstant.baseUrlV2 + "summarytstat/CallSummarystat"),
      this._Http.post(ApiConstant.baseUrlV2 + "skystat/CallSkystat", {
        _ApYear: "2021",
      }),
    ];

    return forkJoin(requests);
  }
}
